module.exports = "/_next/static/media/c705c85edec1c329f88a852106538144.png";